import { Component, ViewContainerRef, TemplateRef, ElementRef, ViewChild } from '@angular/core';
import { CategoryService } from '../../services/category/category.service';
import { Category } from '../../models/category/category.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Sales } from '../../models/sales/sales.model';
import { SaleCategories } from '../../models/sales/sales.model';
import { SaleProducts } from '../../models/sales/sales.model'; 
import { Payment } from '../../models/payment/payment-model';
import { PaymentService } from '../../services/payment/payment.service';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { ProductService } from '../../services/product/product.service';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CookieService } from 'ngx-cookie-service';
import { DragulaService } from 'ng2-dragula';

@Component({
    selector: 'app-edit-category-level-sales',
    templateUrl: './edit-category-level-sales.component.html',
    styleUrls: ['./edit-category-level-sales.component.css']
})
/** edit-category-level-sales component*/
export class EditCategoryLevelSalesComponent {
  isFileDownload: boolean;
  isFileUpload: boolean;
  @ViewChild('fileDownload') fileDownload: ElementRef;
  productsList: SaleProducts[];
  public saleProduct = new SaleProducts();
  public ExportProductList: SaleProducts[];
  ProductExist: boolean;
  public showSuggestions: boolean;
  saleProductList: SaleProducts[] = [];
  public subCategory = new Category();
  public Category = new Category();
  public parentCategory = new Category();
  public startDateElement: any;
  public endDateElement: any;
  public sales = new Sales();
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public subcategoryList: Category[];
  public subcategoryid: number;
  public parentCategoryId: number;
  public saleCategories = new SaleCategories();
  public paymentList: Payment[];
  salesType: number;
  salesTypeModel: string;
  compnaylevel: boolean;
  Criteria: boolean;
  parentCategoryExist: boolean;
  categorylevel: boolean;
  paymentlevel: boolean;
  saleCategoryList: SaleCategories[] = [];
  saleID: number;
  urls = new Array<string>();
  files: any;
  public progress: number;
  public message: string;
  fileToUpload: File;
  
  disable: boolean;
  selectedSaleLogo: string;
  editSaleLogo: string;
  public mediaList: MediaLibrary[];
  mediaImageShow: boolean;
  modalRef: BsModalRef;
  isSubmit :boolean;
  config = {
    animated: true
  };
  userId: number;
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  regDate: Date;
  endRegDate: Date;
  public bulkProduct: any;
  public Importfiles: boolean= false;
  public FormDataFile: FormData;
    /** edit-category-level-sales ctor */
  constructor(private http: HttpClient, private dragulaService: DragulaService, private readonly paymentService: PaymentService, private _avRoute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly categoryService: CategoryService, private router: Router, private readonly productService: ProductService, private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService, private readonly rolePermissionService: RolePermissionService, private cookieService: CookieService) {    
    this.isFileDownload = true;
    this.isFileUpload = false;
    this.Importfiles = false;
    try {
      this.dragulaService.destroy("VAMPIRES");
    } catch (e) {
    }
    this.dragulaService.createGroup("VAMPIRES", {

    });
    this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
    });
    this.rolePermissionService.GetRolePermissions("categorysale").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);

            if (this._avRoute.snapshot.params["id"]) {
              this.getsaleById(this._avRoute.snapshot.params["id"]);
            }
            this.sales = new Sales();
            this.Criteria = false;
            this.disable = false;
            this.saleCategories.criteria = 0;
            this.parentCategoryExist = false;
            this.isSubmit = true;
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
          }
          else {
            this.router.navigate(["/sale-list"]);
          }
        }
        else {
          this.router.navigate(["/sale-list"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.regDate = new Date();
    this.endRegDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.editSaleLogo = Image.fileName;

    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.sales.saleLogo = this.editSaleLogo;
    this.selectedSaleLogo = "";
    this.modalRef.hide();
  }
  HidePopup() {
    this.editSaleLogo = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  keyPress(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  onSearch(searchText: string) {
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      this.showSuggestions = false;
      return;
    }
    if (length > 0) {
      this.productService.ProductSuggestions(searchText).subscribe(
        data => {
          this.productsList = data;
          if (this.productsList.length > 0) this.showSuggestions = true;
        });
    }
    else {
      this.productsList = [];
      this.showSuggestions = false;
    }
  }
  SearchProduct() {
    this.bulkProduct;
    if (this.bulkProduct != "") {
    this.productService.ProductBulk(this.bulkProduct).subscribe(
      data => {
        if (data)
          this.productsList = data;
        for (var i = 0; i < this.productsList.length; i++) {
          this.productsList[i].disable = true;
          this.SelectProduct(this.productsList[i]);
        }
        this.bulkProduct = "";
        });
    }
    else {
      this.toastr.error('Please Enter Product Id', 'Error');
    }
  }
  SelectProduct(saleProduct: SaleProducts) {
    this.saleProduct = saleProduct;
    this.saleProduct.discountType = 2;
    if (this.saleProduct.disable == true) {
    this.saleProduct.showProductFixed = true;
      this.saleProduct.showProductPercent = false;
    }
    if (!this.saleProductList.some((item) => item.productID == this.saleProduct.productID)) {
      this.saleProductList.push(this.saleProduct);
    }
    else {
      this.toastr.error('This item is already Exist', 'Fail!');
    }
    this.saleProduct = new SaleProducts();
    this.showSuggestions = false;
    this.ProductExist = false;
  }

  removeProduct(cat: SaleProducts, index: number) {
    for (let i = 0; i < this.saleProductList.length; i++) {
      var obj = this.saleProductList[i];
      var check = false;

      if (obj.productID == cat.productID) {
        this.saleProductList.splice(index, 1);
        check = true;
      }
      if (check) return true;
    }

  }
  getsaleById(id: string) {
    this.categoryService.GetSaleByIdImage(id).subscribe(
      data => {
        this.sales = data;
        this.sales.startDate = this.formatDate(this.sales.startDate);
        this.sales.endDate = this.formatDate(this.sales.endDate);
        this.sales.applyDate = this.formatDate(this.sales.applyDate);
        this.salesTypeModel = this.sales.saleTypeID.toString();
        this.salesType = this.sales.saleTypeID;
        if (this.salesType  == 1) {
          this.compnaylevel = true;
          this.categorylevel = false;
          this.paymentlevel = false;
          this.saleProductList = [];
          this.categoryService.GetSaleProductsById(this.sales.saleID).subscribe(
            data => {
              this.saleProductList = data;
              for (var i = 0; i < this.saleProductList.length; i++) {
                if (this.saleProductList[i].venderParticipation == 0) {
                  this.saleProductList[i].disable = true;             
                }
                if (this.saleProductList[i].discountType == 1) {
                  this.saleProductList[i].showProductPercent = true;
                }
                else {
                  this.saleProductList[i].showProductFixed = true;
                }
                //else {
                //  this.saleProductList[i].disable = true;
                //}
              }
            })  
        }
        else if (this.salesType  == 2) {
          this.compnaylevel = false;
          this.categorylevel = true;
          this.paymentlevel = false;
          this.GetCategoryList();
          this.categoryService.GetSaleCategoriesById(this.sales.saleID).subscribe(
            data => {
              this.saleCategoryList = data;
            })  
        }
        else if (this.salesType  == 3) {
          this.compnaylevel = false;
          this.categorylevel = false;
          this.paymentlevel = true;
          
          this.getpaymentmethods();
        }
      //  this.urls.push("/Images/SaleImages/" + this.sales.saleID + "-img.jpg");
      }
    )
  }
  selectStartDate(e) {
    if (e != null) {
      this.sales.startDate = e;
      //this.minDate=e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
    //  this.endMaxDate.setDate(this.maxDate.getDate() + 1);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.sales.endDate = e;
      this.regDate = e;
      this.endRegDate = new Date(this.regDate);
   //   this.endRegDate.setDate(this.regDate.getDate() - 1);
    }
  }
  selectRegistrationDateDate(e) {
    if (e != null) {
      this.sales.applyDate = e;
    }
  }
  formatDate(date: string): string {
    let newDate: any = date.split('-');
    let days: number = parseInt(newDate[2]);
    let months: number = parseInt(newDate[1]);
    let year: number = parseInt(newDate[0]);
    return months + "/" + days + "/" + year;
  }


 



  getpaymentmethods() {
    this.paymentService.getActivePaymentMethods().subscribe(
      data => {
        this.paymentList = data;
      }
    )
  }



  ShowSection(typeid: number) {
    this.salesType = typeid;
    this.sales.saleTypeID = this.salesType;
    if (typeid == 1) {
      this.compnaylevel = true;
      this.categorylevel = false;
      this.paymentlevel = false;
    }
    else if (typeid == 2) {
      this.compnaylevel = false;
      this.categorylevel = true;
      this.paymentlevel = false;
      this.showSuggestions = false;
      this.saleCategories.parentCategoryID = null;
      this.GetCategoryList();
    }
    else if (typeid == 3) {
      this.compnaylevel = false;
      this.categorylevel = false;
      this.paymentlevel = true;
      this.showSuggestions = false;
      this.getpaymentmethods();
    }


  }
  //UploadImages(event) {
  //  this.urls = [];
  //  let files = event;
  //  this.files = files;
  //  if (files) {
  //    for (let file of files) {
  //      let reader = new FileReader();
  //      reader.onload = (e: any) => {
  //        this.urls.push(e.target.result);
  //      }
  //      reader.readAsDataURL(file);
  //    }
  //  }
  //}
  UploadImages(file: FileList) {
    this.fileToUpload = file.item(0);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.sales.saleLogo = "";
      this.mediaImageShow = true;
      this.selectedSaleLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }

  GetCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data;
        this.saleCategories.parentCategoryID = null;
        this.saleCategories.parentCategoryName = data[0].categoryName;
        this.saleCategories.categoryID = 0;
        this.saleCategories.categoryName = "All";
        this.saleCategories.subCategoryID = 0;
        this.saleCategories.subCategoryName = "All";
        //this.GetCategoryListByParent(data[0].categoryID);
      }
    )
  }
  GetCategoryListByParent(parentCategoryId: number) {
    if (parentCategoryId > 0) {
      this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
        data => {
          this.categoryList = data;
          this.parentCategoryExist = false;
       //   this.GetSubCategoryListByParent(data[0].categoryID);
        }
      )
      // set parent select value

      this.parentCategoryList.forEach(obj => {
        if (obj.categoryID == parentCategoryId) {
          this.saleCategories.parentCategoryID = parentCategoryId;
          this.saleCategories.parentCategoryName = obj.categoryName;
          return false;
        }
      });
    }
    else {
      this.categoryList = [];
      this.saleCategories.categoryID = this.categoryList[0].categoryID;
      this.saleCategories.categoryName = this.categoryList[0].categoryName;
    }



  }
  HideCriteriaMessage() {
    this.Criteria = false;
  }
  GetSubCategoryListByParent(parentCategoryId: number) {
    if (parentCategoryId > 0) {
      this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
        data => {
          this.subcategoryList = data;
        }
      )
      // set parent select value

      this.categoryList.forEach(obj => {
        if (obj.categoryID == parentCategoryId) {
          this.saleCategories.categoryID = parentCategoryId;
          this.saleCategories.categoryName = obj.categoryName;
          return false;
        }
      });

    }
    else {
      this.subcategoryList = [];
      this.saleCategories.categoryID = 0;
      this.saleCategories.categoryName = "All";
    }

  }
  GetCategoryValue(CategoryId: number) {

    // set parent select value
    if (CategoryId > 0) {
      this.subcategoryList.forEach(obj => {
        if (obj.categoryID == CategoryId) {
          this.saleCategories.subCategoryID = CategoryId;
          this.saleCategories.subCategoryName = obj.categoryName;
          return false;
        }
      });

    }
    else {
      this.saleCategories.subCategoryID = 0;
      this.saleCategories.subCategoryName = "All";
    }



  }
  upload() {
    try {
      if (typeof this.fileToUpload == "undefined") {

        this.toastr.success('Sale has been Updated.', 'Success!');
        setTimeout(() => {
          this.router.navigate(["/sale-list"]);
        }, 2000);
      }
    } catch (e) {
      this.toastr.success('Sale has been Updated.', 'Success!');
      setTimeout(() => {
        this.router.navigate(["/sale-list"]);
      }, 2000);
    }
    if (typeof this.fileToUpload != "undefined") {
      const formData = new FormData();
     // for (let file of this.files) formData.append(file.name, file);
      // add ProductID
      formData.append("SaleLogo", this.fileToUpload);
      formData.append("SaleID", this.saleID.toString());

      //let headers = new HttpHeaders();
      //headers.set("Token", this.cookieService.get('Login'));

      const uploadReq = new HttpRequest('POST', `api/Category/UploadFile?userId=` + this.userId, formData, {
        reportProgress: true,
        headers: new HttpHeaders({ "Token": this.cookieService.get('Login')})
      });

      this.http.request(uploadReq).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response)
          this.message = event.body.toString();
      });
      this.toastr.success('Sale has been Updated.', 'Success!');
      setTimeout(() => {
        this.router.navigate(["/sale-list"]);
      }, 2000);
    }
  }
  GetDomain(type: number) {

    this.sales.domainType = type;

  }
  addCategory() {
    if (this.saleCategories.criteria > 0 && this.saleCategories.parentCategoryID > 0) {
      this.Criteria = false;
      this.parentCategoryExist = false;
      if (this.saleCategories.categoryID == 0) {
        this.saleCategories.categoryID = 0;
        this.saleCategories.categoryName = "All";
      }
      if (this.saleCategories.subCategoryID == 0) {
        this.saleCategories.subCategoryID = 0;
        this.saleCategories.subCategoryName = "All";
      }
      var node = new SaleCategories();
      node = this.saleCategories;
      this.saleCategoryList.push(node);
      this.saleCategories = new SaleCategories();
      this.GetCategoryList();
    }
    else if (this.saleCategories.parentCategoryID == null) {
      this.parentCategoryExist = true;
    }
    else {
      this.Criteria = true;
    }
  }
  removeCatgory(cat: SaleCategories, index: number) {

    for (let i = 0; i < this.saleCategoryList.length; i++) {
      var obj = this.saleCategoryList[i];
      var check = false;

      if (obj.categoryID == cat.categoryID && obj.parentCategoryID == cat.parentCategoryID && obj.subCategoryID == cat.subCategoryID) {
        this.saleCategoryList.splice(index, 1);
        check = true;
      }
      if (check) return true;
    }

  }
  onSubmit() {
    if (this.salesType == 2) {
      if (this.saleCategoryList.length == 0) {
        this.parentCategoryExist = true;
        return;
      }
      else {

        var result2 = this.saleCategoryList.filter(x => x.criteria == null);
        result2.forEach(obj => {
          if (obj.criteria == null) {
            obj.criteria = 0;
          }
        });
        this.sales.saleCategories = this.saleCategoryList;

       
       // this.saleCategoryList = [];
        this.parentCategoryExist = false;
      }
    }
    if (this.salesType == 1) {
      if (this.saleProductList.length == 0) {
        this.ProductExist = true;
        return;
      }
      else {

        var result = this.saleProductList.filter(x => x.companyParticipation == null);
        result.forEach(obj => {
          if (obj.companyParticipation == null) {
            obj.companyParticipation = 0;
          }
        });
        this.sales.saleProducts = this.saleProductList;
      //  this.saleProductList = [];
        this.ProductExist = false;
      }

    }
    this.isSubmit = false;
    //this.startDateElement = document.getElementById("startDate") as HTMLElement;
    //this.endDateElement = document.getElementById("endDate") as HTMLElement;
    this.sales.saleTypeID = this.salesType;
    //this.sales.startDate = new Date(this.startDateElement.value).toDateString();
    //this.sales.endDate = new Date(this.endDateElement.value).toDateString();
    //this.sales.applyDate = this.sales.endDate;
    this.categoryService.AddSale(this.sales).subscribe(
      data => {

        if (data > 0) {        
          this.saleID = data;
          this.upload();
     //     this.sales = new Sales();
        }
        else {
          this.toastr.error('Unable to save', 'Fail!');
        }
      });

  }
  checkPercent(event: any) {
    if (this.sales.dicsountPercent > 100) {
      this.sales.dicsountPercent = 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      this.sales.dicsountPercent = null;
      return false;
    }
    return true;

  }
  checkPercentProduct(event: any, i: number) {
    if (this.saleProductList[i].companyParticipation > 100) {
      this.saleProductList[i].companyParticipation = 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      this.saleProductList[i].companyParticipation = null;
      return false;
    }
    return true;

  }
  setPercent(i: number) {
    if (this.saleProductList[i].discountType == 1) {
      this.saleProductList[i].showProductPercent = true;
      this.saleProductList[i].showProductFixed = false;
    }
    else {
      this.saleProductList[i].showProductPercent = false;
      this.saleProductList[i].showProductFixed = true;
    }
  }

  sampleFile() {
    this.productService.SampleSaleProducts().subscribe(
      data => {
        if (data.status == 1) {
          var path = data.data;
          window.open("/Files/WidgetTemplates/" + path);
          this.toastr.success(data.message, 'Success');
        }
      });
    }
  
  fileChanged(event) {
    this.Importfiles = event.target.files[0];
  }
 


  genrateColumns(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();
    for (let file of files)
      formData.append(file.name, file);
    this.FormDataFile = formData;
    this.Importfiles = true;
  }

  ImportProducts() {
    if (!this.Importfiles) {
      this.toastr.error("Please Select File", 'Error');
      return;
    }
    this.isFileUpload = true;
    this.productService.SaleProductUpload(this.FormDataFile).subscribe(
      data => {
        this.saleProductList = data;

        for (var i = 0; i < this.saleProductList.length; i++) {
          if (this.saleProductList[i].venderParticipation == 0) {
            this.saleProductList[i].disable = true;
          }
          if (this.saleProductList[i].discountType == 1) {
            this.saleProductList[i].showProductPercent = true;
          }
          else {
            this.saleProductList[i].showProductFixed = true;
          }
          //else {
          //  this.saleProductList[i].disable = true;
          //}
        }


        if (this.saleProductList.length > 0) {
          this.toastr.success("Products Upload Successfully", 'Success');
          this.isFileUpload = false;
        }
      });
  }



  exportProducts() {
    if (this.saleProductList == null || this.saleProductList.length <= 0) {
      this.toastr.info("No Products to Export", 'Info');
      this.isFileDownload = true;
    }
    else {
      if (this.isFileDownload) {
        this.isFileDownload = false;
        this.ExportProductList = this.saleProductList;
        this.productService.ExportSaleProducts(this.ExportProductList).subscribe(
          data => {
            if (data.status == 1) {
              var path = data.data;
              window.open("/Files/" + path);
              //this.fileDownload.nativeElement.href = ;
              //this.fileDownload.nativeElement.click();
              this.toastr.success(data.message, 'Success');
              this.isFileDownload = true;
            }
            else {
              this.toastr.error(data.message, 'Error');
              this.isFileDownload = true;
            }
          })
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/edit-category-level-sales/edit-category-level-sales.component.ts